import { defineMessages } from 'react-intl';

export const gatewayMessages = defineMessages({
    sidePanel: {
        id: 'side-panel',
        defaultMessage: 'Details',
    },
    outsideOfParking: {
        id: 'outside-of-parking',
        defaultMessage: 'Outside of parking',
    },
    passedOn: {
        id: 'passed-on',
        defaultMessage: 'Passed on',
    },
    passId: {
        id: 'pass-id',
        defaultMessage: 'Pass ID',
    },
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    gatewayPass: {
        id: 'gateway-pass',
        defaultMessage: 'Gateway pass',
    },
    gatewayPasses: {
        id: 'gateway-passes',
        defaultMessage: 'Gateway passes',
    },
    pass: {
        id: 'pass',
        defaultMessage: 'Pass',
    },
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    parkingStay: {
        id: 'parking-stay',
        defaultMessage: 'Parking stay',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    eventLog: {
        id: 'event-log',
        defaultMessage: 'Event log',
    },
});
